import styled from 'styled-components';
import SistemaList from '~/pages/Sistema/componentes/SistemaList';
import { Scrollbars } from 'react-custom-scrollbars';
import { Colors } from "~/config/Colors";

export const Main = styled.div`
  display: flex;
  flex-direction: row;
  height: 100%;

  .col {
    margin: 0 !important;
  }

  .no-padd-l {
    padding-left: 0 !important;
  }

  .filtro {
    margin: 0.6em 0 0.6em 0;

    select, input {
      height: 3.2em;
      font-size: 0.58em;
    }
  }

  .basic-multi-select .select__control {
    margin-top: 0.12em !important;
  }

  .content {
    padding: 0em;
    display: grid;
    gap: 0em;
    height: 100%;

    .materialize {
      padding: 0.8em 0.8em 0.5em 0.8em;
    }

    .header {
      display: flex;
      width: 100%;
      flex-direction: row;
      justify-content: space-between;

      .btn-filtro {
        height: 1.9em;
        width: 5em;
        padding: 0em;
        font-family: 'Nunito', 'cursive';
        min-width: fit-content;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 0.8em;
        font-weight: 500;
        background-color: #FFAB48;
        color: ${Colors.Color2};
        border: 0.25em solid #FFAB48;
        border-radius: 0.625em;
      }
    }
  
    .divTitle {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
      width: 100%;

      .div-icone {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        background: ${Colors.Color2};
        border-radius: 0.4em;
        padding: 0.15em 0.8em 0.15em 0.3em;

        .title {
          font-size: 1.1em;
          font-weight: 700;
          color: ${Colors?.Color3};
        }

        .sub-title {
          font-size: 0.75em;
          font-weight: 500;
          color: ${Colors?.Color15};
        }
      }

      .subTitle {
        margin-top: 0.5em;
        font-size: 0.7125em;
        font-weight: 500;
        color: ${Colors?.Color7};
      }
    }

    .back-section {
      padding: 0em;
      background: ${Colors.Color2};
      position: relative;
      display: grid;
      gap: 1em;
      overflow: auto;
      padding: 1em;
      
      .ref {
        position: relative;
        display: grid;
        gap: 1em;
      }

      .section-1,
      .section-2 {
        display: grid;
        width: 100%;
        border-radius: 0.8em;

        .sc-top {
          padding: 0.4em 0.8em;
          background: ${Colors.Color8};
          border-radius: 7px;
          width: 100%;
          
          .div-title {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            width: 100%;
            
            .title {
              width: fit-content;
              color: ${Colors.Color3};
              font-size: 0.7em;
              font-weight: 800;
            }

            .icon-arrow {
              width: 0.7em;
            }

            .total-satis {
              display: flex;
              flex-direction: row;

              .resumo {
                display: flex;
                flex-direction: column;
                align-items: center;
                margin-right: 1.3em;

                .ct-title {
                  width: fit-content;
                  font-size: 0.45em;
                  font-weight: 800;
                }
                  
                .ct-quant {
                  width: fit-content;
                  font-size: 0.6em;
                  margin-top: -0.3em;
                  font-weight: 800;
                  color: ${Colors.Color7};
                }
              }
            }
          }

          .div-sumary {
            padding: 0 0.5em;
            display: grid;
            grid-auto-flow: column;
            justify-content: space-between;
            gap: 1em;

            .list {
              display: grid;
              grid-auto-columns: max-content;
              grid-auto-flow: column;
              gap: 1em;
              padding: 0.7em 0;
              
              .click {
                cursor: pointer;
              }

              .item-pergunta.desativado {
                img {
                  filter: grayscale(100%);	;
                }
              }

              .item-pergunta {
                display: flex;
                flex-direction: row;
                justify-content: flex-start;
                align-items: center;

                img {
                  width: 2rem;
                }

                .titulo-item {
                  width: fit-content;
                  font-size: 0.7em;
                  font-weight: 600;
                  color: ${Colors?.Color7};
                }

                .align-right {
                  display: flex;
                  flex-direction: row;
                  justify-content: flex-end;
                  align-items: center;
                }

                .align-left {
                  display: flex;
                  flex-direction: row;
                  justify-content: flex-start;
                  align-items: center;
                }

                .align-center {
                  display: flex;
                  flex-direction: row;
                  justify-content: center;
                  align-items: center;
                }

                .col-1 {
                  width: 5rem;
                }
                
                .col-1-1 {
                  width: 3rem;
                }

                .col-1-2 {
                  width: 2rem;
                }
                
                .col-2 {
                  width: 10rem;
                }
                
                .col-3 {
                  width: 15rem;
                }
              }
            }
            
            .chart-total {
              width: 6em;
              display: flex;
              flex-direction: row;
              align-items: flex-start;

              .chart-tt-circle {
                width: 100%;
                border-radius: 1em;
                background: ${Colors.Color16};
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;

                .text-group {
                  margin-top: -1em !important;
                }
              }
            }
          }
        }
      }

      .section-1 {
        background: ${Colors.Color2};
        gap: 1em;

        .chart-barra {
          display: grid;
          grid-template-columns: auto 18em;
          gap: 1em;
          width: 100%;
          padding: 0 1em;
        
          .chart-total {
            width: 100%;
            display: flex;
            flex-direction: row;
            align-items: flex-start;

            .chart-tt-circle {
              width: 100%;
              height: 100%;
              padding: 0.5em 0;
              border-radius: 1em;
              background: ${Colors.Color16};
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;

              .ct-percent {
                width: fit-content;
                font-size: 1.2em;
                font-weight: 800;
              }

              .divisor {
                content: "";
                width: 2em;
                height: 0.2em;
                border-radius: 1em;
                margin: 0em 0em 0.2em 0;
              }

              .dv-colo1 {
                background: #2ed3b5;
              }

              .dv-colo2 {
                background: #B6DF53;
              }

              .dv-colo3 {
                background: #FFD147;
              }

              .dv-colo4 {
                background: #FFAB48;
              }

              .dv-colo5 {
                background: #FF5780;
              }

              .ct-title {
                width: fit-content;
                font-size: 0.8em;
                font-weight: 800;
              }
                
              .ct-quant {
                width: fit-content;
                font-size: 1em;
                font-weight: 800;
                color: ${Colors.Color7};
              }
            }
          }
          
          .list {
            display: grid;
            gap: 0.6em;
            height: fit-content;

            .item-pergunta {
              display: flex;
              flex-direction: row;
              justify-content: flex-start;
              align-items: center;

              img {
                width: 2rem;
              }

              .titulo-item {
                width: fit-content;
                font-size: 0.7em;
                font-weight: 600;
                color: ${Colors?.Color7};
              }

              .progress {
                width: 100%;
                margin-left: 0.5em;
                border-radius: 1rem;
                background: ${localStorage.getItem("tema") == "E" ? "#15141a" : "#f1f1f1"};
                height: 1em;
              }

              .align-right {
                display: flex;
                flex-direction: row;
                justify-content: flex-end;
                align-items: center;
              }

              .align-left {
                display: flex;
                flex-direction: row;
                justify-content: flex-start;
                align-items: center;
              }

              .align-center {
                display: flex;
                flex-direction: row;
                justify-content: center;
                align-items: center;
              }

              .col-1 {
                width: 5rem;
              }
              
              .col-1-1 {
                width: 3rem;
              }
              
              .col-2 {
                width: 10rem;
              }

              .col-3 {
                width: 15rem;
              }

              .col-4 {
                width: 20rem;
              }
              
              .col-5 {
                width: 25rem;
              }

              .col-6 {
                width: 30rem;
              }
            }
          }
        }
      }

      .section-2 {
        background: ${Colors.Color8};

        .lista-comentarios {
          flex-direction: column !important;
          height: 18em;
          overflow: auto;
        }

        .ref2 {
          display: grid;
          width: 100%;
        }
      }
    }
  }

`;

export const ContainerComm = styled(SistemaList)`
  height: 100%;
  overflow: auto;
`;

export const LandPage = styled(Scrollbars)`
  width: calc(100%) !important;
`;

export const Container = styled.div``;

export const ThisProgress = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  content: "";
  width: ${props => props?.width};
  height: 0.9em;
  border-radius: 1em;
  background: ${props => props?.backgound};
  animation-name: liq;
  animation-duration: 2s;
  animation-fill-mode: forwards;

  @keyframes liq {
    from {width: 0;}
  }
`;

export const ThisCarregamento = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  content: "";
  width: 100%;
  height: 0.15em;
  border-radius: 1em;
  background: #f8f8f8;

  ::after {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    content: "";
    width: ${props => props?.cronometro}%;
    height: 0.15em;
    border-radius: 1em;
    background: ${Colors?.Color23};
    animation: bounce 20s ease-in-out infinite;
    
    @keyframes bounce {
      from {width: 0%;}
      to {width: 100%;}
    }
  }
`;